export const escapeHtml = (str: any): string => {
	if (!str) return '';
	return String(str)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
};

/**
 * Tooltip body for analytics charts in comparison mode.
 */
export const buildSeriesComparisonTooltipHtml = (
	rows: Array<{ label: string; color: string; value: string; dashed?: boolean }>,
	options?: { minWidth?: number; title?: string }
): string => {
	const minWidth = (options && options.minWidth) || 220;
	const title = options && options.title;
	const buildSwatch = (color: string, dashed: boolean | undefined) => {
		const safeColor = escapeHtml(color);
		if (dashed === undefined) {
			return `<span class="analytics-comparison-tooltip-swatch-square" style="background-color:${safeColor}"></span>`;
		}
		if (dashed) {
			return `<svg width="24" height="2" class="analytics-comparison-tooltip-swatch-line-svg" aria-hidden="true"><line x1="0" y1="1" x2="24" y2="1" stroke="${safeColor}" stroke-width="2" stroke-dasharray="4 4"></line></svg>`;
		}
		return `<span class="analytics-comparison-tooltip-swatch-line" style="background-color:${safeColor}"></span>`;
	};
	const titleHtml = title
		? `<div class="analytics-comparison-tooltip-title">${escapeHtml(title)}</div>`
		: '';
	const body = rows
		.map(
			(row) => `
		<div class="analytics-comparison-tooltip-row">
			<span class="analytics-comparison-tooltip-label">
				${buildSwatch(row.color, row.dashed)}
				${escapeHtml(row.label)}
			</span>
			<span class="analytics-comparison-tooltip-value">${escapeHtml(row.value)}</span>
		</div>`
		)
		.join('');
	return `<div class="analytics-comparison-tooltip" style="min-width:${minWidth}px">${titleHtml}${body}</div>`;
};

export const buildGroupedComparisonTooltipHtml = (
	groups: Array<{
		swatchColor: string;
		heading: string;
		rows: Array<{ label: string; value: string }>;
	}>,
	options?: { minWidth?: number; title?: string }
): string => {
	const minWidth = (options && options.minWidth) || 220;
	const title = options && options.title;
	const titleHtml = title
		? `<div class="analytics-grouped-tooltip-title">${escapeHtml(title)}</div>`
		: '';
	const groupsHtml = groups
		.map((group) => {
			const headingHtml = group.heading
				? `<div class="analytics-grouped-tooltip-heading">` +
				  `<span class="analytics-grouped-tooltip-swatch" style="background-color:${escapeHtml(
						group.swatchColor
				  )}"></span>` +
				  `<span class="analytics-grouped-tooltip-range">${escapeHtml(group.heading)}</span>` +
				  `</div>`
				: '';
			const rowsHtml = group.rows
				.map(
					(row) =>
						`<div class="analytics-grouped-tooltip-metric">` +
						`<span class="analytics-grouped-tooltip-metric-label">${escapeHtml(row.label)}</span>` +
						`<span class="analytics-grouped-tooltip-metric-value">${escapeHtml(row.value)}</span>` +
						`</div>`
				)
				.join('');
			return `<div class="analytics-grouped-tooltip-group">${headingHtml}${rowsHtml}</div>`;
		})
		.join('');
	return (
		`<div class="analytics-grouped-tooltip" style="min-width:${minWidth}px">` +
		titleHtml +
		`<div class="analytics-grouped-tooltip-body">${groupsHtml}</div>` +
		`</div>`
	);
};
